import { render } from "./checkbox-input-pdp.vue?vue&type=template&id=58bda4df"
import script from "./checkbox-input-pdp.vue?vue&type=script&lang=js"
export * from "./checkbox-input-pdp.vue?vue&type=script&lang=js"

import "./checkbox-input-pdp.vue?vue&type=style&index=0&id=58bda4df&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__